
import { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import BreadCrumb from '../Components/Common/BreadCrumb';
import { Autocomplete, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from '@mui/x-data-grid';
import { createdAttendance, downloadAttendanceList, getAttendanceList, getWorkshopList, updateAttendance } from '../api/casp/workshop';
import { DefaultPerPageValue, PerPage, Role } from '../constants/Common';
import { AttendanceType } from '../constants/Status';
import { toast } from 'react-toastify';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';
import Radio from '@mui/material/Radio';
import SearchDropDownListPaginationComponent from "../Components/casp/common/SearchDropDownPaginationList"
import { getAllPortfolios } from '../api/casp/portfolio';
import { useSelector } from 'react-redux';
// import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  wrap_data_grid: {
    "& .MuiDataGrid-cell": {
      padding: "0 !important",
    },
  },
});

const AttendancePage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const classes = useStyles();
  const [attendanceList, setAttendanceList] = useState([]);
  const [workshopList, setWorkshopList] = useState([]);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [page, setPage] = useState(0);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [rowCount, setRowCount] = useState(0);
  const [portfolio,setPortfolio] = useState()
  const [filterFields,setFilterFields] = useState([]);
  const [filterInputs,setFilterInputs] = useState([])
  const {t} = useTranslation();
  const loggedInUser = useSelector((state) => state.Profile.user);

  useEffect(() => {
    if(portfolio){
    getAllWorkshop()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolio])

  useEffect(() => {
    // if (workshopList?.length > 0 && portfolio!==null) {
    //   getAllAttendance(selectedWorkshop)
    // }
    

    if (selectedWorkshop!==null && portfolio!==null) {
      getAllAttendance(selectedWorkshop)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerData])

  useEffect(() => {
    if(selectedWorkshop === null || portfolio === null){
      setAttendanceList([])
    }
  },[selectedWorkshop,portfolio])

  const paginationModelMethod = async (data) => {
    setPage(data.page);
    setRowsPerPage(data.pageSize);
    setTriggerData(+new Date());
  };

  const getAllWorkshop = async () => {
    try {
      const res = (
        await getWorkshopList({
          isAttendance: true,
          portfolioId: portfolio?.id 
        })
      ).data.data;
      const result = res?.map((item) => {
        return {
          value: item?.id,
          label: item?.name
        }
      })
      setWorkshopList(result)
    } catch (err) {
      console.log(err)
    }
  }

  const getAllAttendance = async (workshop) => {
    try {
      const payload = {
        workshopId: workshop?.value,
          page: page + 1,
          perPage: rowsPerPage,
      }

      if (filterFields.length > 0) {
        payload.filterFields = filterFields;
        payload.filterInputs = filterInputs;
      }
      const res = (
        await getAttendanceList(payload)
      ).data;
      const result = res?.data?.data?.map((item) => {
        const attendance = item?.attendances?.[0]
        return {
          id: item?.id,
          startupname: item?.name,
          attendance: attendance?.attendanceType === AttendanceType.ATTENDANCE ? attendance?.attendanceType : '',
          lateattendance: attendance?.attendanceType === AttendanceType.LATE_ATTENDANCE ? attendance?.attendanceType : '',
          absentexcuse: attendance?.attendanceType === AttendanceType.ATTENDANE_WITH_EXCUSE ? attendance?.attendanceType : '',
          absentwithoutexcuse: attendance?.attendanceType === AttendanceType.ATTENDANCE_WITHOUT_EXCUSE ? attendance?.attendanceType : '',
          attendanceId: attendance?.id
        }
      })
      setRowCount(res?.data.meta.total);
      setAttendanceList(result)
    } catch (err) {
      console.log(err)
    }
  }

  const handleUpdateProjectAttenance = async (data, attendanceId) => {
    try {
      const response = attendanceId ? await updateAttendance(attendanceId, data) : await createdAttendance(data);
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        setAttendanceList([]);
        setPage(0)
        setTriggerData(+new Date());
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const columns = [
    { field: 'startupname', headerName: t('Startup name'), width: 250 },
    {
      field: 'attendance',
      headerName: t('Attendance'),
      width: 250,
      renderCell: (params) => {
        const isChecked = params?.row?.attendance === AttendanceType.ATTENDANCE;

        return (
          <div className="d-flex align-items-center">
            {isChecked ? (
              <CheckCircleOutlineIcon style={{ color: 'red', fontSize: 22 }} />
            ) : (
              <Radio
                name="simple-controlled"
                className='p-0'
                value={AttendanceType.ATTENDANCE}
                checked={isChecked}
                onChange={(event) => {
                  if (isChecked) return;

                  handleUpdateProjectAttenance(
                    {
                      attendanceType: event?.target?.value,
                      projectId: params.row.id,
                      workshopId: selectedWorkshop?.value,
                    },
                    params.row?.attendanceId
                  );
                }}
              />
            )}
          </div>
        );
        // <div className="d-flex align-items-center">
        //   <Radio
        //     name="simple-controlled"
        //     value={AttendanceType.ATTENDANCE}
        //     checked={params?.row?.attendance}
        //     onChange={(event) => {
        //       if (params?.row?.attendance === AttendanceType.ATTENDANCE) {
        //         return
        //       }

        //       handleUpdateProjectAttenance({ attendanceType: event?.target?.value, projectId: params.row.id, workshopId: selectedWorkshop?.value }, params.row?.attendanceId)
        //     }} />
        // </div>
      },
    },
    {
      field: 'lateattendance',
      headerName: t('Late Attendance'),
      width: 250,
      renderCell: (params) => {
        const isLateChecked = params?.row?.lateattendance === AttendanceType.LATE_ATTENDANCE;

        return (
          <div className="d-flex align-items-center">
            {isLateChecked ? (
              <CheckCircleOutlineIcon style={{ color: 'green', fontSize: 24 }} />
            ) : (
              <Radio
                name="simple-controlled"
                 className='p-0'
                value={AttendanceType.LATE_ATTENDANCE}
                checked={isLateChecked}
                onChange={(event) => {
                  if (isLateChecked) return;

                  handleUpdateProjectAttenance(
                    {
                      attendanceType: event?.target?.value,
                      projectId: params.row.id,
                      workshopId: selectedWorkshop?.value,
                    },
                    params.row?.attendanceId
                  );
                }}
              />
            )}
          </div>
        );
        // <div className="d-flex align-items-center">
        //   <Radio
        //     name="simple-controlled"
        //     value={AttendanceType.LATE_ATTENDANCE}
        //     checked={params?.row?.lateattendance}
        //     onChange={(event) => {
        //       if (params?.row?.lateattendance === AttendanceType.LATE_ATTENDANCE) {
        //         return
        //       }
        //       handleUpdateProjectAttenance({ attendanceType: event?.target?.value, projectId: params.row.id, workshopId: selectedWorkshop?.value }, params.row?.attendanceId)
        //     }} />
        // </div>
     },
    },
    {
      field: 'absentexcuse',
      headerName: t('Absent with Excuse'),
      width: 250,
      renderCell: (params) => {
        const isChecked = params?.row?.absentexcuse === AttendanceType.ATTENDANE_WITH_EXCUSE;

        return (
          <div className="d-flex align-items-center">
            {isChecked ? (
              <CheckCircleOutlineIcon style={{ color: 'green', fontSize: 24 }} />
            ) : (
              <Radio
                name="simple-controlled"
                 className='p-0'
                value={AttendanceType.ATTENDANE_WITH_EXCUSE}
                checked={isChecked}
                onChange={(event) => {
                  if (isChecked) return;

                  handleUpdateProjectAttenance(
                    {
                      attendanceType: event?.target?.value,
                      projectId: params.row.id,
                      workshopId: selectedWorkshop?.value,
                    },
                    params.row?.attendanceId
                  );
                }}
              />
            )}
          </div>
        );
        // <div className="d-flex align-items-center">
        //   <Radio
        //     name="simple-controlled"
        //     value={AttendanceType.ATTENDANE_WITH_EXCUSE}
        //     checked={params?.row?.absentexcuse}
        //     onChange={(event) => {
        //       if (params?.row?.absentexcuse === AttendanceType.ATTENDANE_WITH_EXCUSE) {
        //         return
        //       }
        //       handleUpdateProjectAttenance({ attendanceType: event?.target?.value, projectId: params.row.id, workshopId: selectedWorkshop?.value }, params.row?.attendanceId)
        //     }} />
        // </div>
     },
    },
    {
      field: 'absentwithoutexcuse',
      headerName: t('Absent without Excuse'),
      width: 250,
      renderCell: (params) => {
        const isChecked = params?.row?.absentwithoutexcuse === AttendanceType.ATTENDANCE_WITHOUT_EXCUSE;
        return (
          <div className="d-flex align-items-center">
            {isChecked ? (
              <CheckCircleOutlineIcon style={{ color: 'green',fontSize: 24 }} />
            ) : (
              <Radio
                name="simple-controlled"
                 className='p-0'
                value={AttendanceType.ATTENDANCE_WITHOUT_EXCUSE}
                checked={isChecked}
                onChange={(event) => {
                  if (isChecked) return;

                  handleUpdateProjectAttenance(
                    {
                      attendanceType: event?.target?.value,
                      projectId: params.row.id,
                      workshopId: selectedWorkshop?.value,
                    },
                    params.row?.attendanceId
                  );
                }}
              />
            )}
          </div>
            );
        // <div className="d-flex align-items-center">
        //   <Radio
        //     name="simple-controlled"
        //     value={AttendanceType.ATTENDANCE_WITHOUT_EXCUSE}
        //     checked={params?.row?.absentwithoutexcuse}
        //     onChange={(event) => {
        //       if (params?.row?.absentwithoutexcuse === AttendanceType.ATTENDANCE_WITHOUT_EXCUSE) {
        //         return
        //       }
        //       handleUpdateProjectAttenance({ attendanceType: event?.target?.value, projectId: params.row.id, workshopId: selectedWorkshop?.value }, params.row?.attendanceId)
        //     }} />
        // </div>
     },
    },
  ];


  // download excel
  const downloadExcel = async () => {
    try {
      const response = await downloadAttendanceList({
        workshopId: selectedWorkshop.value,
        portfolioId: portfolio?.id
      });

      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'attendance.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
    }
  };

  const getRowId = (row) => row.id;

  return (
    <div className="page-content position-relative">
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="mainPageHeader d-flex justify-content-between">
            <BreadCrumb title={t("Attendance")} />
          </div>
          <div className="d-flex justify-content-end ongoingSearchField">
            {selectedWorkshop && <div className="me-2">
              {
                <button
                  className="download_excel d-flex justify-content-center px-3 py-5"
                  onClick={downloadExcel}
                >
                  <p className="mb-0">{("Download Excel")}</p>
                </button>
              }
            </div>}
            <div className="me-2">
              <SearchDropDownListPaginationComponent
                  label={t("Cohort")}
                  sx={{
                  width: 200,
                  }}
                  searchEnabled={false}
                  listCall={getAllPortfolios}
                  disableClearable={!portfolio}
                  defaultValue={portfolio}
                  apiParams={{
                      order: "updatedAt",
                      direction: "desc",
                      ...(![
                          Role.PROJECT_MANAGER,
                          Role.EPMO_MANAGER,
                          Role.ROOT_ADMIN,
                          Role.VICE_PRESIDENT,
                          Role.PRESIDENT,
                          Role.PROGRAM_MANAGER,
                          Role.EPMO_OFFICER,
                          Role.MENTOR
                      ].includes(loggedInUser?.role?.name) && {
                          filterFields: "portfolioUser",
                          filterInputs: loggedInUser.id,
                      }),
                  }}
                  emitItem={(newValue) => {
                  setPortfolio(newValue);
                  setSelectedWorkshop(null)

                  if (newValue?.id) {
                    setFilterFields(['portfolioId']);
                    setFilterInputs([newValue.id]);
                  } else {
                    setFilterFields([]);
                    setFilterInputs([]);
                  }

                  setTriggerData(+new Date());
                  
                  }}
              />
            </div>
            <div className="me-2">
              <Autocomplete
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedWorkshop}
                size="small"
                sx={{ width: "280px" }}
                getOptionLabel={(option) => option?.label}
                options={workshopList}
                onChange={(event, newValue) => {
                  // setPortfolio(null)
                  if (newValue) {
                    setSelectedWorkshop(newValue)
                    getAllAttendance(newValue)
                  } else {
                    setSelectedWorkshop()
                    setAttendanceList([])
                    setRowCount()
                  }
                  setTriggerData(+new Date());
                }}
                noOptionsText={t("No workshops available")}
                loadingText={t("Loading...")}
                renderInput={(params) => <TextField {...params}
                  label={t("Select Workshop / Event Name")}
                />}
              />
            </div>
          </div>
        </div>
        <div className="accordionTable my-4" style={{ width: "100%" }}>
          <div className={classes.wrap_data_grid}>
          <DataGrid
            rows={attendanceList}
            columns={columns}
            // pageSize={5}
            // rowsPerPageOptions={[5]}
            disableRowSelectionOnClick
            autoHeight
            initialState={{
              pagination: {
                paginationModel: { pageSize: rowsPerPage },
              },
            }}
            paginationMode="server"
            paginationModel={{ page: page, pageSize: rowsPerPage }}
            onPaginationModelChange={paginationModelMethod}
            rowCount={rowCount}
            pageSizeOptions={PerPage}
            getRowId={getRowId}
            loading={isLoading}
            sortingMode="server"
            localeText={{
              MuiTablePagination: {
                labelRowsPerPage: t("Rows per page:"),
              },
              noRowsLabel: t("No startup available for attendance."),
            }}
            // hideFooter={true}
          />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AttendancePage;
